import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  DASHBOARD_KNOWLEDGE_NAV,
  DASHBOARD_MCP_NAV,
  DASHBOARD_BASECAMP_NAV,
  DASHBOARD_AI_NAV,
  DASHBOARD_OUTLOOK_NAV,
  DASHBOARD_SHAREPOINT_NAV,
  DASHBOARD_ONENOTE_NAV,
  DASHBOARD_ADMIN_NAV,
  DASHBOARD_DOCUMENTATION_NAV,
} from '../../lib/dashboardNav'
import { navigateFromAdminSidebarItem } from '../../lib/mainShellNav'
import { BandHeading } from './OverviewPanel'

const PLATFORM_CLUSTERS = [
  { id: 'knowledge', title: 'Knowledge Base', items: DASHBOARD_KNOWLEDGE_NAV, beta: false },
  { id: 'mcp', title: 'MCP Server', items: DASHBOARD_MCP_NAV, beta: true },
  { id: 'basecamp', title: 'Basecamp', items: DASHBOARD_BASECAMP_NAV, beta: false },
  { id: 'ai-admin', title: 'AI', items: DASHBOARD_AI_NAV, beta: false },
  { id: 'outlook', title: 'Outlook', items: DASHBOARD_OUTLOOK_NAV, beta: false },
  { id: 'sharepoints', title: 'SharePoint', items: DASHBOARD_SHAREPOINT_NAV, beta: false },
  { id: 'onenote', title: 'OneNote', items: DASHBOARD_ONENOTE_NAV, beta: false },
  { id: 'admin', title: 'Administration', items: DASHBOARD_ADMIN_NAV, beta: false },
  { id: 'docs', title: 'Documentations', items: DASHBOARD_DOCUMENTATION_NAV, beta: false },
]

/**
 * Admin platform clusters — only clusters with ≥1 accessible child.
 */
export default function PlatformClusters({ canAccessPage }) {
  const navigate = useNavigate()

  const clusters = PLATFORM_CLUSTERS.map((c) => ({
    ...c,
    items: c.items.filter((n) => canAccessPage(n.id)),
  })).filter((c) => c.items.length > 0)

  if (!clusters.length) return null

  return (
    <section className="overview-band overview-fade-in" aria-label="Platform">
      <BandHeading
        title="Platform"
        subtitle="Admin areas granted to your role — restricted tools are never listed"
      />
      <div className="overview-cluster-list">
        {clusters.map((cluster) => (
          <div key={cluster.id} className="overview-cluster">
            <div className="overview-cluster-label">
              <span>{cluster.title}</span>
              {cluster.beta ? <span className="overview-beta">Beta</span> : null}
            </div>
            <div className="overview-cluster-links">
              {cluster.items.map(({ id, label, Icon, beta }) => (
                <button
                  key={id}
                  type="button"
                  className="overview-cluster-link"
                  onClick={() => navigateFromAdminSidebarItem(id, navigate)}
                >
                  {Icon ? <Icon size={15} strokeWidth={2} aria-hidden /> : null}
                  <span>{label}</span>
                  {beta ? <span className="overview-beta overview-beta--sm">Beta</span> : null}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
